import {PureComponent} from "react";
import {log} from "@/helpers/logger.js";

class SafePureComponent extends PureComponent {
  componentDidMount() {
    try {
      if(this.safeComponentDidMount) this.safeComponentDidMount();
    } catch (err) {
      log('error', err);
    }
  }

  render() {
    try {
      return this.safeRender();
    } catch (err) {
      log('error', err);
      return null;
    }
  }
}

export default SafePureComponent;
